var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncentives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 73H92.6665M47.6665 28L37.6665 48M47.6665 28L57.6665 48M47.6665 28H25.1665C21.8513 28 18.6719 26.683 16.3277 24.3388C13.9835 21.9946 12.6665 18.8152 12.6665 15.5C12.6665 12.1848 13.9835 9.00535 16.3277 6.66115C18.6719 4.31695 21.8513 3 25.1665 3C42.6665 3 47.6665 28 47.6665 28ZM47.6665 28H70.1665C73.4815 28 76.661 26.683 79.0055 24.3388C81.3495 21.9946 82.6665 18.8152 82.6665 15.5C82.6665 12.1848 81.3495 9.00535 79.0055 6.66115C76.661 4.31695 73.4815 3 70.1665 3C52.6665 3 47.6665 28 47.6665 28ZM18.6665 93H76.6665C82.267 93 85.0675 93 87.2065 91.91C89.088 90.9515 90.618 89.4215 91.5765 87.54C92.6665 85.401 92.6665 82.6005 92.6665 77V44C92.6665 38.3995 92.6665 35.5992 91.5765 33.4601C90.618 31.5785 89.088 30.0486 87.2065 29.0899C85.0675 28 82.267 28 76.6665 28H18.6665C13.066 28 10.2657 28 8.1266 29.0899C6.24495 30.0486 4.71515 31.5785 3.75645 33.4601C2.6665 35.5992 2.6665 38.3995 2.6665 44V77C2.6665 82.6005 2.6665 85.401 3.75645 87.54C4.71515 89.4215 6.24495 90.9515 8.1266 91.91C10.2657 93 13.066 93 18.6665 93Z",
    stroke: "url(#paint0_linear_310_32863)",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_32863",
    x1: 2.6665,
    y1: 48,
    x2: 92.6663,
    y2: 48.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncentives);
export default __webpack_public_path__ + "static/media/incentives.0a84f3698374f5134e79f583a7498529.svg";
export { ForwardRef as ReactComponent };